<template>
	<carousel
		:navigationPrevLabel="`<div class=&quot;slider-prev&quot;></div>`"
		:navigationNextLabel="`<div class=&quot;slider-next&quot;></div>`"
		:paginationEnabled="false"
		:loop="true"
		:navigationEnabled="true"
		:autoplay="true"
		:autoplayTimeout="7000"
		:autoplayHoverPause="true"
		paginationPosition="bottom-overlay"
		:perPage="1"
	>
		<slide v-for="(banner, idx) in banners" :key="idx">
			<div @click="promoBonusBanner(banner)">
				<a
					v-if="banner.external"
					:href="banner.route"
					target="_blank"
					rel="noopener noreferrer"
				>
					<img class="slider__item" :src="banner.src" :alt="banner.alt" />
				</a>
				<router-link v-else :to="banner.route">
					<img class="slider__item" :src="banner.src" :alt="banner.alt" />
				</router-link>
			</div>
		</slide>
	</carousel>
</template>
<script>
export default {
	name: "Slider",
	props: {
		banners: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			name: "slider",
			options: {
				autoplay: {
					delay: 7000,
					disableOnInteraction: true,
				},
				direction: "horizontal",
				grabCursor: true,
				setWrapperSize: true,
				autoHeight: true,
				loop: true,
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				paginationClickable: true,
				autoplayDisableOnInteraction: false,
			},
		};
	},
	methods: {
		promoBonusBanner(banner) {
			let vm = this;
			const promoLink =
				banner.route.substring(0, 100) || vm.$route.path.substring(0, 100);
			this.analyticsTrack("general", "promotionClick", {
				promotion_name: banner.alt,
				promotion_cta: promoLink,
			});
		},
	},
};
</script>
<style lang="scss">
.slider {
	height: auto;
	margin-bottom: -3px;
	width: 100%;
	&__item {
		width: 100%;
		height: auto;
	}
}
.slider-prev,
.slider-next {
	width: 22px;
	height: 22px;
	position: relative;
	background-repeat: no-repeat;
}
.slider-prev {
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23fff'/%3E%3C/svg%3E");
	left: 45px;
}
.slider-next {
	right: 45px;
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23fff'/%3E%3C/svg%3E");
}
.VueCarousel-navigation-prev.VueCarousel-navigation-button,
.VueCarousel-navigation-next.VueCarousel-navigation-button {
	outline: none !important;
	border: none !important;
}
.VueCarousel-dot:focus {
	outline: none !important;
	border: none !important;
}
.VueCarousel-dot-container {
	position: relative;
	top: -20px;
}
@media (min-width: 600px) {
	.VueCarousel-dot-container {
		top: -40px;
	}
}
@media (max-width: 471px) {
	.slider-prev,
	.slider-next {
		display: none;
	}
}
</style>
